<template>
    <div class="bg-dgreen4 pt-6 pb-4 px-6 w-auto rounded-t-xl relative pr-32 mr-6">
        <strong class="font-semibold mb-1 block">Direct antwoord op je vraag?</strong>
        <p class="text-gray-600 text-sm">
            Stel je vraag aan <strong>Kevin</strong>,<br />
            <strong>cilinderspecialist</strong> binnen Doorax.
        </p>

        <div class="inline-block mt-3">
            <div class="flex my-1" v-for="channel in channels" :key="channel.title">
                <div class="flex items-center w-48">
                    <div class="w-8">
                        <fa
                            class="inline-block text-base text-dgreen mr-3"
                            :class="channel.class"
                            :icon="[channel.iconType, channel.icon]"
                        />
                    </div>

                    <a :href="channel.url ?? 'javascript:void(0)'" @click="channel.openChat" :target="channel.icon == 'envelope' ? '_blank' : ''" class="">
                        <strong class="block text-sm font-semibold">{{ channel.title }}</strong>
                    </a>
                </div>
            </div>
        </div>

        <!-- Kevin -->
        <div class="absolute right-2 bottom-0 overflow-hidden">
            <vue-picture
                class="hidden md:block"
                :image="{
                    src: asset('img/kevin.webp'),
                    origin_src: asset('img/kevin.png'),
                }"
                name="Kevin klantenservice"
                :notlazy="true"
                :width="130"
                :height="240"
                :style="'-mr-6'"
            />
            <vue-picture
                class="block md:hidden"
                :image="{
                    src: asset('img/kevin.webp'),
                    origin_src: asset('img/kevin.png'),
                }"
                name="Kevin klantenservice"
                :notlazy="true"
                :width="120"
                :height="180"
            />
        </div>
    </div>
</template>

<script setup>

const props = defineProps({
    post: Object,
});

const channels = [
    {
        title: 'Live chat',
        response: 'Direct contact',
        openChat: () => {
            window.mitt.emit('open-intercom')
        },
        icon: 'comments',
        iconType: 'fas',
    },
    {
        title: '026-2340303',
        response: 'Direct contact',
        url: 'tel:+31262340303',
        icon: 'phone',
        iconType: 'fas',
    },
];
</script>
